<template>
    <div class="count-input">
        <div v-if="false" class="minus" @click="decrement(value-2)">
            -
        </div>
        <input
            ref="countInput"
            :readonly="readonly"
            :value="formattedValue"
            type="text"
            @focus="focus">
        <div class="plus" @click="increment()">
            +
        </div>
    </div>
</template>

<script>
  export default {
    props: ['decrement', 'increment', 'value', 'text', 'required', 'readonly'],
    computed: {
      formattedValue() {
        return this.value + ' ' + this.text
      }
    },
    methods: {
      focus() {
        if(this.readonly != undefined){ this.$refs.countInput.blur() }
      }
    }
  }
</script>

<style lang="scss">
  @import '~@stylesheets/_vars.scss';

  .count-input {
    width: 100%;
    display: flex;
    user-select: none;

    .minus, .plus {
      cursor: pointer;
      font-size: 30px;
      line-height: 28px;
      margin-top: 10px;
      padding: 10px 20px;
      box-sizing: border-box;
      border: 1px solid $light_gray_a;
      background-color: $light_gray_c;
      &:hover{
        background-color: $light_gray_a;
      }
    }

    .minus {
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;

      html.tablet &, html.desktop & {
        order: 1;
        border-right: none;
        border-radius: 0;
      }
    }

    .plus {
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;

      html.tablet &, html.desktop & {
        order: 2;
      }
    }

    input {
      cursor: default;
      border-radius: 0 !important;
      border-right: none !important;
      text-align: center !important;

      &:focus {
        box-shadow: none !important;
      }

      html.tablet &, html.desktop & {
        border-left: 1px solid $light_gray_a !important;
        border-right: none !important;
        border-top-left-radius: 3px !important;
        border-bottom-left-radius: 3px !important;
      }
    }
  }
</style>
